import { Login } from '@myosh/myosh-login';
import { useLocation, useNavigate } from 'react-router';
import { getRequestedUsername } from '@/utils/requested-username';

export const LoginPage = () => {
  const navigate = useNavigate();
  const { search } = useLocation();

  return <Login onLoginSuccess={() => void navigate('/')} username={getRequestedUsername(search)} />;
};
